import Link from "next/link";
import SingleProduct from "../ecommerce/singleProduct/SingleProduct";
import Breadcrumb2 from "../layout/Breadcrumb2";
import TableTypeList from "../products/list/TableTypeList";
import * as S from "./Search.styles";
import { Spinner } from "react-bootstrap";
import FilterList from "../filterList/FilterList";

const SearchUI = ({
  router,
  viewType,
  handleListViewType,
  searchList,
  searchTerm,
  dummyList,
  purchaseDirect,
  searchedTotal,
  moveToDetail,
  moreProducts,
  cateViewStats,
}) => {
  const sizeTxt =
    `${router.query?.garo > 0 ? `가로 ${router.query.garo} ` : ""}` +
    `${router.query?.sero > 0 ? `세로 ${router.query.sero} ` : ""}` +
    `${router.query?.high > 0 ? `높이 ${router.query.high} ` : ""}` +
    `${router.query?.erange > 0 ? `오차범위 ${router.query.erange}` : ""}`;

  return (
    <>
      <S.Container>
        <div className="container">
          {/* 모바일 헤더 */}
          <div className="m_title">
            <Breadcrumb2
              categoryName={
                router.query
                  ? `${router.query.search && `'${router.query.search}'`}` +
                    (router.query.search && sizeTxt && ", ") +
                    "(으)로 검색한 결과"
                  : ""
              }
              categoryHash={""}
              hash={router.query.hash}
            />
          </div>
          {/* 상품 목록 */}
          <div>
            <Breadcrumb2
              categoryName={
                router.query
                  ? `${router.query.search && `'${router.query.search}'`}` +
                    (router.query.search && sizeTxt && ", ") +
                    sizeTxt +
                    "(으)로 검색한 결과"
                  : ""
              }
              categoryHash={router.query.search + sizeTxt}
              productFilters={""}
            />
            <S.FilterWrapper className="">
              {searchedTotal > 0 && (
                <span className="cnt">
                  <strong className="text-brand">{searchedTotal}</strong>
                  개의 상품
                </span>
              )}
            </S.FilterWrapper>
            {router.query && (
              <>
                <S.ProductsGrid className="">
                  {searchList.data &&
                    Object.keys(searchList.data).length === 0 && (
                      <S.ProductsSignWrapper style={{ gridColumn: "span 4" }}>
                        <h4>
                          찾으시는 상품이 없다면 우측 하단의 채널톡으로 문의를
                          넣어주시거나
                        </h4>
                        <h4>맞춤제작 서비스를 이용해보세요.</h4>
                        <a
                          className="btn"
                          href="/customizing/customizing-products/"
                        >
                          맞춤제작 바로가기
                        </a>
                      </S.ProductsSignWrapper>
                    )}
                </S.ProductsGrid>
                {searchList?.data &&
                  Object.keys(searchList.data).length > 0 &&
                  Object.keys(searchList.data).map((key, i) => (
                    <S.ListWraper key={i}>
                      <S.CategoryTitle>{key}</S.CategoryTitle>
                      <S.ProductsGrid>
                        {searchList.data &&
                          searchList.data[key]
                            .slice(
                              cateViewStats[key]?.start || 0,
                              cateViewStats[key]?.last || 8
                            )
                            .map((item, itemIdx) => (
                              <SingleProduct
                                key={itemIdx}
                                product={item}
                                dummyList={dummyList}
                                listViewType={viewType ? viewType : "grid"}
                              />
                            ))}
                      </S.ProductsGrid>
                      {cateViewStats[key]?.last <=
                        searchList.data[key].length && (
                        <S.MoreBtn onClick={() => moreProducts(key)}>
                          검색된 {key} 더보기
                        </S.MoreBtn>
                      )}
                    </S.ListWraper>
                  ))}
                {searchList?.community?.data &&
                  searchList.community?.data.length > 0 && (
                    <S.ListWraper>
                      <S.CategoryTitle>관련 게시물</S.CategoryTitle>
                      <S.SearchedCommunity>
                        {searchList.community.data
                          .slice(
                            cateViewStats.community?.start || 0,
                            cateViewStats.community?.last || 8
                          )
                          .map((el, i) => (
                            <S.CommunityBox
                              key={i}
                              onClick={() => moveToDetail(el.id)}
                            >
                              <div className="thumbnail">
                                <img src={el.thumbnail} />
                              </div>
                              <div className="title">
                                <h5>{el.title}</h5>
                              </div>
                              <h6 className="sub_title">{el.sub_title}</h6>
                            </S.CommunityBox>
                          ))}
                      </S.SearchedCommunity>
                      {cateViewStats?.community?.last <=
                        searchList.community.data.length && (
                        <S.MoreBtn onClick={() => moreProducts("community")}>
                          검색된 게시물 더보기
                        </S.MoreBtn>
                      )}
                    </S.ListWraper>
                  )}
              </>
            )}
          </div>
        </div>
      </S.Container>
    </>
  );
};
export default SearchUI;
